import {
    activityRecordTypeForGoalMetricItemLinkKind,
    GoalMetricItemLink,
} from "@sp-crm/core";
import { hrefForActivityRecord } from "util/activity-record-href";

export const goalMetricItemHref = (link: GoalMetricItemLink): string =>
    hrefForActivityRecord(
        activityRecordTypeForGoalMetricItemLinkKind[link.kind],
        link.entityId,
    );
